import TermsOfUse from '../components/TermsOfUse/TermsOfUse.vue'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {          
            path: '/termsofuse',
            name: 'Termos de Uso',
            component: TermsOfUse
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/terms_of_use.js